// extracted by mini-css-extract-plugin
export default {"actions":"Cajas_actions__QONge","download":"Cajas_download__F4jRB","mes":"Cajas_mes__2dZvF","abierta":"Cajas_abierta__Y2ERO","descuadre":"Cajas_descuadre__Pmmtb"};